// removed by extract-text-webpack-plugin
module.exports = {"bigButton":"pJumsFN7UtUvZekVJc3QG","bigButton2":"_3FmvG0BvJnrrlf2Txq_8W_"};


//////////////////
// WEBPACK FOOTER
// ./src/forms/registrationSchool/registrationSchoolForm.scss
// module id = 693
// module chunks = 22